export default "__VITE_ASSET__COf2cQET__"